<template>
  <v-row justify="center">
    <v-dialog
        v-model="model"
        scrollable
        @click:outside="fecharModal"
        :persistent="persistencia"
        :max-width="maxWidth"
        style="padding: 0">
      <v-card class="card-component">
        <v-toolbar dark color="primary" elevation="0">
          <v-toolbar-title>{{ titulo }}</v-toolbar-title>
          <v-spacer/>
          <v-btn class="close__button" text @click="cancelar" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="container-color-picker">
          <v-color-picker v-if="permiteTransparencia" v-model="corSelecionada"/>
          <v-color-picker v-else
                          v-model="corSelecionada"
                          hide-mode-switch
                          hide-inputs
                          :dot-size="20"
                          show-swatches
                          :swatches-max-height="90"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="cancelar" color="black">Cancelar</v-btn>
          <v-btn @click="confirmar" text color="red">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import _ from 'lodash'

export default {
    name: 'ColorPickerModal',
    props: {
        value: {
            type: Boolean,
            required: true
        },
        corPadrao: String,
        titulo: {
            type: String,
            default: 'Selecione a cor desejada'
        },
        persistencia: {
            type: Boolean,
            default: true
        },
        maxWidth: {
            type: Number,
            default: 400
        },
        permiteTransparencia: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    data() {
        return {
            corSelecionada: '',
        }
    },
    mounted() {
        if (this.corPadrao) {
            this.corSelecionada = _.cloneDeep(this.corPadrao)
        }
    },
    methods: {
        fecharModal() {
            if (!this.persistencia) {
                this.cancelar()
            }
        },
        cancelar() {
            this.model = false
            this.$emit('cancelarSelecionarCor')
        },
        confirmar() {

            if (!this.permiteTransparencia) {
                this.corSelecionada = this.removerAlphaTransparencia(this.corSelecionada)
            }
            this.model = false
            this.$emit('confirmarSelecionarCor', this.corSelecionada)
        },
        removerAlphaTransparencia(color) {
            if (!color) return null

            // HEX com alpha: #RRGGBBAA
            if (/^#([A-Fa-f0-9]{8})$/.test(color)) {
                return `#${color.substring(1, 7)}`
            }
            // HEX normal: #RGB ou #RRGGBB
            if (/^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/.test(color)) {
                return color
            }
            // RGB ou RGBA
            const rgbaMatch = color.match(
                /rgba?\s*\(\s*(\d+),\s*(\d+),\s*(\d+)/
            )
            if (rgbaMatch) {
                const r = parseInt(rgbaMatch[1]).toString(16).padStart(2, '0')
                const g = parseInt(rgbaMatch[2]).toString(16).padStart(2, '0')
                const b = parseInt(rgbaMatch[3]).toString(16).padStart(2, '0')
                return `#${r}${g}${b}`
            }
            return null
        }
    }

}
</script>

<style scoped lang="stylus">
.card-component
  text-align start
  background-color #FFFFFF
  color #000000

.container-color-picker
  margin-top 20px
  display flex
  justify-content center

</style>